import StringMask from 'string-mask';

export default (value) => {

  if (!value) {

    return value;

  }

  const onlyNums = value.toString().replace(/[^\d]/g, '');

  return new StringMask('#9.99', { reverse: true }).apply(onlyNums);

};



// WEBPACK FOOTER //
// ./src/components/normalize/DecimalNormalize.js